// Sync control for the leads directory. Shows when the encrypted local mirror
// was last synced, and a button to (re)sync the whole database into IndexedDB.

function RefreshIcon({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {/* coolicons: line/Arrows_Reload_01.svg */}
      <path d="M10 16H5V21M14 8H19V3M4.58301 9.0034C5.14369 7.61566 6.08244 6.41304 7.29255 5.53223C8.50266 4.65141 9.93686 4.12752 11.4298 4.02051C12.9227 3.9135 14.4147 4.2274 15.7381 4.92661C17.0615 5.62582 18.1612 6.68254 18.9141 7.97612M19.4176 14.9971C18.8569 16.3848 17.9181 17.5874 16.708 18.4682C15.4979 19.3491 14.0652 19.8723 12.5723 19.9793C11.0794 20.0863 9.58606 19.7725 8.2627 19.0732C6.93933 18.374 5.83882 17.3175 5.08594 16.0239" />
    </svg>
  )
}

// Always day + time: "Last synced today at 6:33 AM" / "Last synced Jul 19 at 4:12 PM".
function syncedLabel(ms) {
  if (!ms) return 'Never synced'
  const d = new Date(ms)
  const time = d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })
  const sameDay = d.toDateString() === new Date().toDateString()
  const day = sameDay ? 'today' : d.toLocaleDateString([], { month: 'short', day: 'numeric' })
  return `Last synced ${day} at ${time}`
}

// `idleLabel` overrides the "Last synced …" text for callers whose refresh is
// not a full server sync — so they can state what they actually did.
export default function SyncButton({ meta, syncing, progress, onSync, idleLabel, title }) {
  // Boolean(): with totalRegions === 0 (sample-data mode, or a caller that
  // passes only lastSynced) the bare `&&` chain evaluates to the NUMBER 0,
  // which JSX renders as a stray "0" after the timestamp.
  const partial = Boolean(
    meta && meta.totalRegions && meta.syncedRegions < meta.totalRegions,
  )

  return (
    <div className="flex items-center gap-x-3">
      <span className="whitespace-nowrap text-[12.5px] text-faint">
        {syncing
          ? progress
            ? `Syncing ${progress.done}/${progress.total}…`
            : 'Syncing…'
          : (
            <>
              {idleLabel || syncedLabel(meta?.lastSynced)}
              {partial && (
                <span className="ml-1 text-warn" title={`${meta.syncedRegions}/${meta.totalRegions} regions cached`}>
                  · partial
                </span>
              )}
            </>
          )}
      </span>
      <button
        type="button"
        onClick={onSync}
        disabled={syncing}
        title={title}
        className="inline-flex flex-none items-center gap-x-1.5 rounded-[9px] border border-line bg-surface px-3 py-[9px] text-[13px] font-semibold text-ink transition-colors hover:bg-panel disabled:cursor-not-allowed disabled:opacity-70"
      >
        <RefreshIcon className={`h-[15px] w-[15px] text-dim ${syncing ? 'animate-spin' : ''}`} />
        {syncing ? 'Syncing…' : 'Sync'}
      </button>
    </div>
  )
}
